<template>
  <ReDocWrapper
    :specOrSpecUrl="`${origin}/${$route.params.domain}/${$route.params.module}`"
  />
</template>

<script>
import ReDocWrapper from "../components/ReDocWrapper";

export default {
  components: {
    ReDocWrapper,
  },
  data() {
    return {
      origin:
        process.env.VUE_APP_SPEC_ORIGIN ||
        "https://apicenter-blob-dev.eis.lumen.com",
    };
  },
};
</script>
